/* Copyright (c) 2017 Backpack Health LLC */

const GroupPhrases = {

  myGroups: (isMainProfile, profileName) => ({
    title: {
      id: isMainProfile ? 'groups.user.title.text' : 'groups.notUser.title.text',
      values: {
        string1: profileName,
      },
    },

  }),

  join: (isMainProfile, profileName) => ({
    agreeCriteria: {
      id: isMainProfile ? 'groupJoinEligibility.agreeCriteriaUser.button.label' : 'groupJoinEligibility.agreeCriteriaNotUser.button.label',
      values: {
        string1: profileName,
      },
    },
    eligibilityConfirmLabel: {
      id: isMainProfile ? 'groupJoinEligibility.joinDependentCheck.message.text' : 'groupJoinEligibility.authorizedJoinDependent.message.text',
      values: {
        string1: profileName,
      },
    },
  }),

};

export default GroupPhrases;
